export enum LogicalOperation {
    Or = 'OR',
    And = 'AND',
}
